__webpack_require__.p = "https://static.futunn.com/components/common-redpacket-share/";